import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  SimpleGrid,
  Flex,
  Icon,
  useColorModeValue,
  VStack,
  Skeleton,
} from '@chakra-ui/react';
import AddDepartment from './AddDepartment';
import Addscheme from './Addscheme';
import AddType from './AddType';
import { FaDatabase } from 'react-icons/fa';

function Index() {
  const [loginRole, setLoginRole] = useState('');
  const [isLoading, setIsLoading] = useState(true); // Added loading state

  const bgGradient = useColorModeValue(
    'linear(to-br, white, blue.50)',
    'linear(to-br, gray.900, blue.900)',
  );
  const textColor = useColorModeValue('gray.800', 'white');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const bgColor = useColorModeValue(
    'linear(135deg, gray.50, blue.100, blue.100)',
    'linear(135deg, black,gray.400, gray.300)',
  );

  useEffect(() => {
    const loadUser = () => {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          const parsed = JSON.parse(userData);
          setLoginRole(parsed.role);
        }
      } catch (error) {
        setLoginRole('');
      } finally {
        setIsLoading(false);
      }
    };

    setTimeout(loadUser, 100);
  }, []);

  const loaderBg = useColorModeValue('gray.50', 'gray.900');
  const loaderPattern = useColorModeValue(
    'radial-gradient(circle at 25px 25px, rgba(120, 119, 198, 0.3) 2%, transparent 0%), radial-gradient(circle at 75px 75px, rgba(120, 119, 198, 0.3) 2%, transparent 0%)',
    'radial-gradient(circle at 25px 25px, rgba(66, 153, 225, 0.15) 2%, transparent 0%), radial-gradient(circle at 75px 75px, rgba(66, 153, 225, 0.15) 2%, transparent 0%)',
  );
  const loaderGradient = useColorModeValue(
    'linear(to-r, blue.400, purple.500)',
    'linear(to-r, blue.500, purple.600)',
  );
  const skeletonStart = useColorModeValue('gray.200', 'gray.700');
  const skeletonEnd = useColorModeValue('gray.300', 'gray.600');
  if (isLoading) {
    return (
      <Flex
        minH="100vh"
        align="center"
        justify="center"
        bg={loaderBg}
        position="relative"
        overflow="hidden"
        borderRadius="20px"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          right="0"
          bottom="0"
          backgroundImage={loaderPattern}
          backgroundSize="100px 100px"
        />

        <Flex direction="column" align="center" gap={6}>
          <Box
            width="100px"
            height="100px"
            borderRadius="full"
            bgGradient={loaderGradient}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={FaDatabase} boxSize={12} color="white" />
          </Box>
          
        </Flex>
      </Flex>
    );
  }

  return (
    <Box
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      pt={{ base: '120px', md: '90px' }}
      px={{ base: '2', md: '4' }}
      pb={8}
      borderRadius="2xl"
      bgGradient={bgColor}
    >
      <Flex
        direction="column"
        mb={2}
        p={3}
        borderRadius="2xl"
        bgGradient={bgGradient}
        boxShadow="0 10px 40px rgba(0, 0, 0, 0.05)"
        position="relative"
        overflow="hidden"
      >
        <Box
          position="absolute"
          top="-50px"
          right="-50px"
          w="200px"
          h="200px"
          borderRadius="full"
          bgGradient="linear(to-br, blue.200, purple.200)"
          opacity={0.1}
        />
        <Box
          position="absolute"
          bottom="-30px"
          left="-30px"
          w="150px"
          h="150px"
          borderRadius="full"
          bgGradient="linear(to-br, teal.200, cyan.200)"
          opacity={0.1}
        />

        <Flex align="center" mb={2} position="relative" zIndex={1}>
          <Flex
            align="center"
            justify="center"
            w="50px"
            h="50px"
            borderRadius="xl"
            bgGradient="linear(to-br, blue.500, purple.600)"
            mr={4}
            boxShadow="0 10px 30px rgba(128, 90, 213, 0.4)"
          >
            <Icon as={FaDatabase} boxSize={6} color="white" />
          </Flex>
          <VStack align="start" spacing={1}>
            <Text fontSize="2xl" fontWeight="bold" color={textColor}>
              Master Data
            </Text>
            <Text color={subtitleColor} fontSize="sm">
              Manage and configure system entities
            </Text>
          </VStack>
        </Flex>
      </Flex>

      {loginRole === 'admin' && (
        <>
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={2}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <AddDepartment />
            <Addscheme />
          </SimpleGrid>
          <div style={{ marginTop: '8px' }}>
            <AddType />
          </div>
        </>
      )}
    </Box>
  );
}

export default Index;
